module.exports = __webpack_public_path__ + "static/media/4641.c1014ecd.jpg";